import STable from './s-table.jsx'

STable.install = function(Vue) {
  Vue.component(STable.name, STable)
}

export default STable